/**
 * PWA 与埋点的启动钩子。
 *
 * 为什么单独一个文件而不是塞进 `main.tsx`：`main.tsx` 应该只做"装配"，
 * 而这两件事都带副作用（注册 Service Worker、监听 visibilitychange），
 * 放在一起会让"应用怎么启动的"变得难读。
 *
 * 两条刻意的取舍：
 * 1. **只在生产构建里注册 Service Worker**。开发期 Vite 的模块图每次热更新都会变，
 *    缓存住的旧模块会导致"改了代码但页面没变"这种最让人抓狂的问题；
 * 2. **注册失败不报错**（隐私模式、不支持、CSP 拦截都可能失败）：
 *    PWA 是增强能力，不是运行前提。
 */

export function registerServiceWorker(): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  // 开发期不注册：见文件头说明
  if (!import.meta.env.PROD) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // 静默失败：离线能力不可用不影响主流程
    });
  });
}
